var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCloseGyeongju({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "close"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M28 12L12 28",
    stroke: "#6C717A",
    strokeWidth: 2.63736,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12 12L28 28",
    stroke: "#6C717A",
    strokeWidth: 2.63736,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseGyeongju);
export default __webpack_public_path__ + "static/media/closeGyeongju.2724967c.svg";
export { ForwardRef as ReactComponent };